<template>
  <div class="prequiz" style="overflow: auto;">
    <component :is="activeView" />
  </div>
</template>

<script>
import Question from "./Question";
import Results from "./Results";
export default {
  components: {
    Question,
    Results
  },
  mounted()
  {
    this.$store.dispatch('startGame');
  },
  computed: {
    activeView() {
      // Get the match object from the store
      const results = this.$store.state.results;
      // Show the question if the question is open, and results if not
      return results ? "Results": "Question";
    },
  }
};
</script>
